import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import useStyles, { getMuiTheme } from "./styles";

import {
  Grid,
  Hidden,
  Typography,
  Tooltip,
  ButtonGroup,
  IconButton,
  Button
} from '@material-ui/core';
import { AddEditEvent } from "../";
import FormInput from "../../../FormInput";
import SelectAllIcon from '@material-ui/icons/SelectAll';
import { Label } from '@material-ui/icons';


const Toolbar = props => {
  const {
    date,
    calendarStartDate,
    calendarEndDate,
    view,
    viewName,
    setViewName,
    onDatePrev,
    onDateNext,
    onEventAdd,
    onViewChange,
    onDateToday,
    className,
    setUserData,
    currentUser,
    userData,
    setIsSubpanelUpdated,
    legendColor,
    CalendarListViewLoading,
    viewOptions,
    ...rest
  } = props;

  const classes = useStyles();
  let legendCount = 0;

  let relateField = {
    comment: null,
    field_key: "relatedRecords",
    label: 'Users',
    massupdate: "false",
    name: "relatedRecords",
    required: "false",
    type: "relate",
    module: 'Users',
  };

  

  const handleChangeView = (viewOption) => {
    if (viewOption.label !== 'Shared Month' && viewOption.label !== 'Shared Week') {
      setUserData(currentUser)
    }
    onViewChange(viewOption.value);
    setViewName(viewOption.label)
  }

  const handleChangeLengend = (legendColorIndex) => {
    console.log("legendColorIndex",legendColorIndex);
  }

  const handleChange = (field, val) => {
    console.log("onChange==========", val)
    let innerData = []
    if(val.length){
       val.map((id) => (
      innerData.push(id)
    ))
       }
    setUserData(innerData)
  };

  const showCalendarDate = () => {
    {
      switch (view) {

        case "timeGridDay":
          return moment(date).format('DD MMMM YYYY');
          break;
        default:
          return moment(calendarStartDate).format('DD MMMM YYYY') + " - " + moment(calendarEndDate).format('DD MMMM YYYY');
      }
    }

  }
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="flex-end"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid item>

          <Typography component={'span'} variant="subtitle2" className={classes.brandLogoTitle} >
            Calendar
          </Typography>

        </Grid>
        <Grid item>

          <AddEditEvent setIsSubpanelUpdated={setIsSubpanelUpdated} />
          {viewName === 'Shared Month' || viewName === 'Shared Week' ?
            <>
              <FormInput
                variant="standard"
                className={classes.textArea}
                field={relateField}
                initialValues={{ 'relatedRecords': [] }}
                value=''
                // setModalVisible={openRelatedTo}
                multiSelect="true"
                isIconBtn="true"
                isSelectBtn="true"
                reportsTo={currentUser}
                view={"calendar"}
                userData={[...new Set(userData)]}
                btnIcon={<SelectAllIcon />}
                onChange={(val) => handleChange("relatedRecords", val)}
              /></> : null}

        </Grid>
      </Grid>
      <Grid
        alignItems="center"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid item>
          <ButtonGroup>
            <Button onClick={onDatePrev}>Prev</Button>
            <Button onClick={onDateToday}>Today</Button>
            <Button onClick={onDateNext}>Next</Button>
          </ButtonGroup>
        </Grid>
        <Hidden smDown>
          <Grid item>
            <Typography variant="h5">
              {
                showCalendarDate()
              }           </Typography>
          </Grid>
          <Grid item>
            <ButtonGroup>

              {viewOptions.map(viewOption => {
                const Icon = viewOption.icon;

                return (
                  <Tooltip
                    key={viewOption.value}
                    title={viewOption.label}
                  >
                    <Button
                      color={viewOption.label === viewName ? 'primary' : 'default'}
                      onClick={() => handleChangeView(viewOption)}
                    >
                      {Icon ? <Icon /> : viewOption.label}
                    </Button>
                  </Tooltip>
                );
              })}
            </ButtonGroup>

          </Grid>
        </Hidden>
      </Grid>
      <Grid
        alignItems="center"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid item>

        </Grid>
        {<Hidden smDown>

          <Grid item style={{display: "flex",width: "100%",justifyContent: "flex-end", paddingTop:"0px", paddingBottom:"0px"}}>
              {/*viewName === 'Shared Week' || viewName === 'Shared Month' ? !CalendarListViewLoading && legendColor && Object.keys(legendColor).map((legendColor1, i) => {*/}
              {!CalendarListViewLoading && legendColor && Object.keys(legendColor).map((legendColor1, i) => {
                return (
                  <Grid item style={{display: "flex",justifyContent: "center"}}>
                  <Typography style={{fontSize:"12px"}}>
                    {legendColor1}
                  </Typography>
                  <Button onClick={() => handleChangeLengend(i)} style={{background:legendColor[legendColor1],width:"10px", height:"10px", minWidth:"10px", margin: "3px 15px 0px 8px"}}></Button>
                  </Grid>
                  );
                }) }

          </Grid>
            </Hidden>}
      </Grid>
    </div>
  );
};

Toolbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  date: PropTypes.any.isRequired,
  onDateNext: PropTypes.func,
  onDatePrev: PropTypes.func,
  onDateToday: PropTypes.func,
  onEventAdd: PropTypes.func,
  onViewChange: PropTypes.func,
  view: PropTypes.string.isRequired,
  legendColor: PropTypes.array,
  CalendarListViewLoading:PropTypes.string
};

export default Toolbar;
